<!-- 列表页 -->
<template>
  <div class="list">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      中国律师网
    </div>
    <div class="news" v-infinite-scroll="queryByCatalog" style="overflow:auto">
      <div class="news-top-moretitle" v-if="newsList.length !== 0">
        <div
          v-for="(item, index) in newsList"
          :key="index"
          :class="
            news === index
              ? 'active-newtitle news-top-moretitle-item'
              : 'news-top-moretitle-item'
          "
          @click="changeBynamic(index,item.id)"
        >
          {{ item.label }}
          <img
            v-show="news === index"
            class="news-top-moreimg"
            src="../assets/images/text-bg.png"
            alt=""
          />
        </div>
      </div>
      <div class="news-item" @click="toDetail(item.id)" v-for="(item, index) in newsContentList" :key="index">
        <div class="news-item-title" v-html="item.properties.title"></div>
        <div class="news-item-date">{{ formatDate(item.$displays.publishedDate) }}</div>
      </div>
      
    </div>
  </div>
</template>

<script>
import api from "../api/index";

export default {
  data() {
    return {
      news: 0,
      type:'',
      newsList: [],
      page:1,
      newsContentList: []
    };
  },
  created(){
    this.newsList = JSON.parse(localStorage.getItem('list'))
    this.parentId = this.newsList[0].id
  },
  methods: {
    formatDate(date) {
      return api.formatDate(date);
    },
    toDetail(entityId) {
      this.$router.push({
        name: "detail",
        params: { entityId: entityId, from: 'list',},
      });
    },
    changeBynamic(index,id){
      this.page = 1
      this.news = index
      this.parentId = id
      this.newsContentList = []
      this.queryByCatalog()
    },
    queryByCatalog(){
      let params = {
        withSubCatalog:false,
        page: this.page++,
        pageSize:10,
        parentId: this.parentId,
      }
      api.queryByCatalog(params).then((res) => {
        if (res.data && res.data.items) {
          this.newsContentList = this.newsContentList.concat(res.data.items)
        }
      });
    },
    toIndex(){
      this.$router.push({
        name: "home"
      });
    }
  },
};
</script>
<style lang='scss' scoped>
.list {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: rgba(255, 255, 255, 0);
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .news {
    margin: 1rem 0;
    width: 100%;
    height: calc(100% - 2.75rem);
    padding: 0.63rem 1rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
    overflow: auto;
    .news-top {
      position: relative;
    }
    .news-top-moretitle {
      width: 100%;
      height: 3rem;
      font-weight: 600;
      font-size: 0.94rem;
      color: rgba(0,0,0,0.65);
      line-height: 3rem;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
      .active-newtitle {
        font-weight: 600;
        font-size: 1.13rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 1.56rem;
      }
      .news-top-moretitle-item {
        position: relative;
        display: inline-block;
        margin-right: 1rem;
        // width: 3.75rem;
        .news-top-moreimg {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 4.5rem;
          height: 0.38rem;
        }
      }
    }
    .news-item {
      margin-top: 0.75rem;
      width: 100%;
      height: 4.93rem;
      border-bottom: 1px solid #e7e6e4;
      .news-item-title {
        height: 3rem;
        font-weight: 500;
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.65);
        line-height: 1.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .news-item-date {
        margin: 0.25rem 0 0.5rem 0;
        text-align: right;
        font-weight: 500;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.25);
        line-height: 1.06rem;
        text-align: right;
      }
    }
    .news-item:last-child {
      border: 0;
    }
  }
}
</style>